import React from "react";
import { Form } from "antd";
import { InputText } from "@comps/components";
import { getErrorProps } from "@utils/helpers";

const RoleForm = ({ onFinish, initialData, formName, errors, setErrors }) => {


  return (
    <Form
      layout="horizontal"
      name={ formName }
      onFinish={ onFinish }
      initialValues={ initialData }
    >
      <Form.Item onChange={
        () => setErrors([])
      } name="name" rules={ rules.name } label="Name :" className="da-mb-16"
        { ...getErrorProps(errors['name']) }
      >
        <InputText placeholder="Enter your role name" />
      </Form.Item>
    </Form>
  )
}


const rules = {
  name: [
    { required: true, message: 'Please input your role name!', },
    { min: 3, message: 'Minimum name length is 3', },
    { max: 100, message: 'Maximum name length is 100', },
  ]
};


export default RoleForm;